/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Breach_TitleInputs */

const en_privacy_breach_title = /** @type {(inputs: Privacy_Breach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Data Breach Notification`)
};

const de_privacy_breach_title = /** @type {(inputs: Privacy_Breach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Benachrichtigung bei Datenschutzverletzungen`)
};

const fr_privacy_breach_title = /** @type {(inputs: Privacy_Breach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Notification de violation de données`)
};

const es_privacy_breach_title = /** @type {(inputs: Privacy_Breach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Notificación de violación de datos`)
};

const it_privacy_breach_title = /** @type {(inputs: Privacy_Breach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Notifica di violazione dei dati`)
};

const nl_privacy_breach_title = /** @type {(inputs: Privacy_Breach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Melding van datalekken`)
};

const pl_privacy_breach_title = /** @type {(inputs: Privacy_Breach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Powiadomienie o naruszeniu danych`)
};

const fi_privacy_breach_title = /** @type {(inputs: Privacy_Breach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Tietoturvaloukkausilmoitus`)
};

const da_privacy_breach_title = /** @type {(inputs: Privacy_Breach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Meddelelse om databrud`)
};

const sv_privacy_breach_title = /** @type {(inputs: Privacy_Breach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Meddelande om dataintrång`)
};

/**
* | output |
* | --- |
* | "10. Data Breach Notification" |
*
* @param {Privacy_Breach_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_breach_title = /** @type {((inputs?: Privacy_Breach_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Breach_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_breach_title(inputs)
	if (locale === "fr") return fr_privacy_breach_title(inputs)
	if (locale === "es") return es_privacy_breach_title(inputs)
	if (locale === "it") return it_privacy_breach_title(inputs)
	if (locale === "nl") return nl_privacy_breach_title(inputs)
	if (locale === "pl") return pl_privacy_breach_title(inputs)
	if (locale === "fi") return fi_privacy_breach_title(inputs)
	if (locale === "da") return da_privacy_breach_title(inputs)
	if (locale === "sv") return sv_privacy_breach_title(inputs)
	return en_privacy_breach_title(inputs)
});